export default __webpack_public_path__ + "static/media/ic_wavax_24.75fe1256.svg";